<template>
  <li class="flex items-start space-x-2">
    <div class="bg-situational-dark mt-2 h-1 w-1 rounded-full"></div>
    <p class="text-text-neutral-tertiary text-sm">
      <slot></slot>
    </p>
  </li>
</template>
